import { ProductSummaryOrder } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { css, TextStyling } from '@thg-commerce/gravity-theme'

export const ExternalIdentifierDisplayContainer = styled.div<{
  order?: ProductSummaryOrder
  textStyle?: TextStyling
}>`
  order: ${(props) => props.order || ProductSummaryOrder.FOUR};
  ${(props) =>
    !props.textStyle
      ? Text('small', 'default')
      : css`
          ${Text(props.textStyle.entry, props.textStyle.style)}
        `} padding: ${spacing(1)} 0;
`
